import React, { useCallback } from 'react'
import cx from 'classnames'
import { Icon, l } from '@manychat/manyui'

import cm from 'apps/chat/controllers/form/Toolbar/Toolbar.module.css'

interface ImageBtnProps {
  disabled?: boolean
  onSelect?: (imageFiles: File[]) => void
  iconType?: 'Image' | 'Plus'
}

const iconProps: Record<
  'Image' | 'Plus',
  { className?: string; size?: number; 'data-title'?: string }
> = {
  Image: { className: cx(cm.icon), 'data-title': l.translate('Image') },
  Plus: { size: 20 },
}

const wrapperProps: Record<'Image' | 'Plus', { className: string }> = {
  Image: { className: cm.wrapperImage },
  Plus: {
    className: cx(cm.wrapperPlus, 'd-flex align-center justify-center rounded m-l-xs'),
  },
}

const ImageBtn = ({ onSelect = () => {}, iconType = 'Image', disabled = false }: ImageBtnProps) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (disabled) {
        return
      }

      const { files } = e.target

      if (files && files.length > 0) {
        onSelect([...files])
      }
    },
    [onSelect, disabled],
  )

  const Component = Icon[iconType]
  const { className } = wrapperProps[iconType]

  return (
    <div
      className={cx(className, {
        [`${cm.disabled} c-not-allowed`]: disabled,
        [`pointer`]: !disabled,
      })}
    >
      <input
        value=""
        type="file"
        name="image-file"
        id="image-file"
        disabled={disabled}
        onChange={handleChange}
        accept=".jpg, .jpeg, .png"
        className="d-none"
        multiple
      />
      <label
        htmlFor="image-file"
        className={cx('d-flex', {
          [`pointer`]: !disabled,
          [`c-not-allowed`]: disabled,
        })}
      >
        <Component {...iconProps[iconType]} />
      </label>
    </div>
  )
}

export { ImageBtn }
